import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'default' | 'primary' | 'danger' | 'ghost';
  size?: 'compact' | 'default' | 'touch' | 'small' | 'normal';
}

export function Button({
  tone = 'default',
  size = 'default',
  className = '',
  ...props
}: ButtonProps) {
  const semanticSize = size === 'small' ? 'compact' : size === 'normal' ? 'default' : size;
  return (
    <button
      className={`button button-${tone} button-size-${semanticSize} ${className}`}
      {...props}
    />
  );
}
